import React from 'react'
import Header from './components/Header';
import { Outlet } from 'react-router-dom';
import { message } from 'antd';


const Layout = () => {
  const [messageApi, contextHolder] = message.useMessage();


  const success = (message) => {
    messageApi.open({
      type: 'success',
      content: message,
    });
  };

  const error = (message) => {
    messageApi.open({
      type: 'error',
      content: message,
    });
  };
  return (
    <div className='bg-slate-100'>
      <Header />
      {contextHolder}
      <div className=''>
        <Outlet context={{success, error}}/>
      </div>
    </div>
  )
}

export default Layout;